import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import SearchForm from '../components/shared/header/search-form';
import UrlParser from '../services/url-parser';

const mapStateToProps = (state, ownProps) => ({
    locale: state.locale,
    taxons: state.taxons,
    searchTerm: UrlParser.getQueryVariable('searchTerm'),
});

const mapDispatchToProps = (dispatch) => ({
    filterTaxons: (taxons) => taxons.filter((taxon) => taxon.attributes.depth <= 1),

    taxonByLink: (taxons, link) => taxons.filter((taxon) => taxon.attributes.permalink === link),

    submitSearchForm: (searchTerm, locale) => {
        dispatch(push(`/search?query=${searchTerm}`));
    },
});

const SearchFormConnector = connect(mapStateToProps, mapDispatchToProps)(SearchForm);

export default SearchFormConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/search-form-connector.js
 **/